/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Title } from './Title';

const ChangeEmailError = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'error'} />
      <Title>{t('NOTIFICATION_CHANGE_EMAIL_ERROR_MODAL__title')}</Title>
    </>
  );
};

export { ChangeEmailError };
